import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInjectSaga } from "utils/saga/injectSaga";
import {
  employeeVerifyRequest,
  otpVerifyRequest,
  rediectingEmployee,
  resendOTPRequest
} from "./actions";
import saga from "./saga";
import SideContentLayout from "layouts/SideContentLayout";
import { NHeader, NLabel, NTerms, NWelcomText, RightContentWrapper } from "./styles";
import EmployeeIDScreen from "./employeeIdScreen";
import OTPScreen from "./otpScreen";
import NEATLogo from "../../assets/neat/neap_logo.svg";
import { useHistory } from "react-router-dom";
import { useQuery } from "share/atoms/use-query";

const key = "studentLogin";

function Login(props) {
  useInjectSaga({ key, saga });
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();
  const {
    employeeVerifyReducer: {
      error,
      data: { employee_id }
    },
    otpVerifyReducer: { data: otpData, error: otpError },
    redirectingReducer: { redirect }
  } = useSelector((state) => state.studentLogin);
  const [visibleScreen, setVisibleScreen] = useState("");

  useEffect(() => {
    const res = sessionStorage.getItem("n-screen");
    setVisibleScreen(res);
  }, [sessionStorage.getItem("n-screen")]);

  const handleSubmit = (e, name) => {
    e.preventDefault();
    dispatch(
      employeeVerifyRequest({
        employee_id: name
      })
    );
  };
  const handleNotYourID = () => {
    sessionStorage.removeItem("n-screen");
    setVisibleScreen("");
    dispatch(rediectingEmployee(false));
  };
  const handleLogin = (otp) => {
    const reqBody = {
      grant_type: process.env.REACT_APP_GRANT_TYPE,
      client_id: process.env.REACT_APP_CLIENT_ID,
      client_secret: process.env.REACT_APP_CLIENT_SECRET,
      employee_id: employee_id || sessionStorage.getItem("n-emp-id"),
      otp: otp
    };
    dispatch(otpVerifyRequest(reqBody));
  };
  const handleResend = () => {
    const admNumber = query.get("admission_number");
    dispatch(
      resendOTPRequest({
        employee_id: admNumber
      })
    );
  };

  const handleTermsConditions = () => {
    history.push("/terms-conditions");
  };

  const handlePrivacyPolicy = () => {
    history.push("/privacy-policy");
  };

  return (
    <SideContentLayout>
      <RightContentWrapper>
        <NHeader>
          <img src={NEATLogo} alt="" />
        </NHeader>
        {visibleScreen === "otp" ? (
          <OTPScreen
            handleNotYourID={handleNotYourID}
            handleLogin={handleLogin}
            handleResend={handleResend}
            error={otpError}
          />
        ) : (
          <EmployeeIDScreen handleSubmit={handleSubmit} error={error} />
        )}
        <NTerms>
          I agree to the{" "}
          <span onClick={handleTermsConditions}>Terms & Conditions</span> and{" "}
          <span onClick={handlePrivacyPolicy}>Privacy Policy</span>.
        </NTerms>
      </RightContentWrapper>
    </SideContentLayout>
  );
}

export default React.memo(Login);
